import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { AppMenuComponent } from '../app-menu/app-menu.component'
import { AppHeaderComponent } from '../app-header/app-header.component'
import { SharedModule } from '../../../shared/shared.module'
import { AlertMessage, AlertService } from '../../../shared/alert.service'
import { Subject, takeUntil } from 'rxjs'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-app-template',
  imports: [RouterOutlet, AppMenuComponent, AppHeaderComponent, SharedModule, CommonModule],
  templateUrl: './app-template.component.html',
  styleUrl: './app-template.component.scss'
})
export class AppTemplateComponent implements OnInit, OnDestroy {
  // alertMessage: string | null = null
  alertMessage: AlertMessage | null = null
  private destroy$ = new Subject<void>()
  constructor(
    private alertService: AlertService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.alertService.message$.pipe(takeUntil(this.destroy$)).subscribe(msg => {
      console.log('ALERT RECEIVED:', msg)

      if (!msg) return

      this.alertMessage = msg
      this.cdr.detectChanges()

      // auto hide
      // setTimeout(() => {
      //   this.alertMessage = null
      //   this.cdr.detectChanges()
      // }, 3000)
    })
    // this.alertService.show(
    //   this.alertMessage?.message || 'Something happened',
    //   this.alertMessage?.type
    // )
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
